/** Decode stored names to plain text. Callers must use textContent or escape at HTML sinks. */
export function decodeHtmlEntitiesForPlainText(value: unknown): string {
    const input = String(value ?? '');
    if (input === '' || !input.includes('&')) return input;
    const textarea = document.createElement('textarea');
    // Names have historically been stored through more than one HTML encoding pass.
    // Match fate_tide_plain_text_decode's bounded decode before textContent/escaping.
    let decoded = input;
    for (let pass = 0; pass < 8; pass++) {
        textarea.innerHTML = decoded;
        if (textarea.value === decoded) break;
        decoded = textarea.value;
    }
    return decoded;
}
